module.exports = __webpack_public_path__ + "img/xvc.95c8612c.svg";